import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const alertVariants = cva(
  'relative text-sm leading-tight text-neutral-dark py-3 px-5 rounded-lg flex items-start gap-2 [&>svg~*]:pl-5 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-3 [&>svg]:text-primary [&>svg]:shrink-0 [&>svg]:size-4',
  {
    variants: {
      variant: {
        default: 'bg-[#F1F5FA] text-foreground',
        plain: 'p-0 gap-1 bg-transparent text-neutral',
        success: 'text-success bg-success-lightest [&>svg]:text-success',
        danger: 'text-danger bg-danger-lightest [&>svg]:text-danger'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn('mb-1 font-medium leading-none tracking-tight', className)}
    {...props}
  />
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('text-sm [&_p]:mb-0 [&_p]:leading-relaxed', className)}
    {...props}
  />
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
